import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "./contexts/ThemeContext";
import { DeprecationNotice } from "./pages/DeprecationNotice";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <DeprecationNotice />
    </ThemeProvider>
  </StrictMode>
);
